
<div fxLayout="row" fxLayout.xs="column">
    <div class="class-mat-field" fxFlex="16.66">
        <mat-select placeholder="Country" [formControl]="countryControl" (selectionChange)="updateRegion()">
            <mat-option [value]="element['id']" *ngFor="let element of countries; let i = index">{{element['full_name']}}</mat-option>
        </mat-select>
    </div>
    <div class="separator"></div>
    <div class="class-mat-field" fxFlex="16.66">
        <mat-select placeholder="Cycle" [formControl]="cycleControl" (selectionChange)="updateInstitutionOrClass('cycle')">
            <mat-option [value]="element['id']" *ngFor="let element of cycles; let i = index">{{element['name']}}</mat-option>
        </mat-select>
    </div>
    <div class="separator"></div>
    <div *ngIf="filterType == 'institution'" class="class-mat-field" fxFlex="16.66">
        <mat-select placeholder="Region" [formControl]="regionControl" (selectionChange)="updateInstitutionOrClass('region')">
            <mat-option [value]="">Select</mat-option>
            <mat-option [value]="element['id']" *ngFor="let element of regions; let i = index">{{element['full_name']}}</mat-option>
        </mat-select>
    </div>
    <div *ngIf="filterType == 'study'" class="class-mat-field" fxFlex="16.66">
        <mat-select placeholder="Class" [formControl]="classControl" (selectionChange)="updateStudy('study')">
            <mat-option [value]="">Select</mat-option>
            <mat-option [value]="element['id']" *ngFor="let element of classes; let i = index">{{element['full_name']}}</mat-option>
        </mat-select>
    </div>
    <div class="separator"></div>
    <div *ngIf="filterType == 'institution'" class="class-mat-field" fxFlex="16.66">
        <mat-select placeholder="Institution" [formControl]="institutionControl" (selectionChange)="setInstitution()">
            <input class="col-input-filter" [formControl]="searchInstitutionControl">
            <mat-option [value]="element['id']" *ngFor="let element of filteredInstitutions; let i = index">{{element['name']}}</mat-option>
        </mat-select>
    </div>
    <div *ngIf="filterType == 'study'" class="class-mat-field" fxFlex="16.66">
        <mat-select placeholder="Study" [formControl]="studyControl" (selectionChange)="setStudy()">
            <input class="col-input-filter" [formControl]="searchStudyControl">
            <mat-option [value]="element['id']" *ngFor="let element of filteredStudies; let i = index">{{element['name']}}</mat-option>
        </mat-select>
    </div>
    
    <div *ngIf="modes.length > 0" class="separator"></div>
    <div *ngIf="modes.length > 0" class="class-mat-field" fxFlex="16.66">
        <mat-select *ngIf="pageId != 'vcl-manage-institution'" class="class-select-field" placeholder="Mode" [formControl]="modeControl" class="multiselect" (selectionChange)="setMode()" multiple>
            <mat-option [value]="element['id']" *ngFor="let element of modes; let i = index">
                <span class="mat-option-content">{{element['value']}}</span>
                <span class="mat-option-checkbox">
                    <mat-icon *ngIf="selectedElement(modeControl, element)" class="mat-icon material-icons check-icon" fontIcon="done"></mat-icon>
                </span>
            </mat-option>
        </mat-select>
         <mat-select *ngIf="pageId == 'vcl-manage-institution'" placeholder="Mode" [formControl]="modeControl" (selectionChange)="setMode()">
            <mat-option [value]="element['id']" *ngFor="let element of modes; let i = index">{{element['value']}}</mat-option>
        </mat-select>
    </div>
    <div *ngIf="hasSearchKey" class="separator"></div>
    <div *ngIf="hasSearchKey" class="class-mat-field" fxFlex="8.33">
        <input type="text" class="col-input-filter" [formControl]="searchControl"  placeholder="Search" style="margin: 0;" value="">
    </div>
    <div class="separator"></div>
    <div class="class-mat-field" fxFlex="16.66"  fxLayoutAlign="center center">
        <button class="button-validate-small" (click) = "chargeData()">Validate</button>
    </div>
</div>